import React from 'react';

export default class EInvitations extends React.Component {
	constructor(props) {
		super(props);
	}

	showModal() {
		this.props.showModal(true);
	}

	showPreview() {
		this.props.showPreview(true);
	}

	render() {

		let invitationButton = this.props.selectedEventDetails.eventStatus !== "Active" ? null : (
			<div>
				<button className="primaryBtn customButton" onClick={this.showModal.bind(this)}>{this.props.resources["PWS.MyAccount.PartyDetailsChangeButton"]}</button>&nbsp;
				<button className="primaryBtn customButton" onClick={this.showPreview.bind(this)}>{this.props.resources["PWS.MyAccount.PartyDetailsPreviewButton"]}</button>
			</div>
		)

        let token = this.props.selectedEventDetails.inviteTemplateToken;
        let templateImage = (token!==null&&token!=="") ? `${window.jenkon.imageEndpoint}${this.props.selectedEventDetails.inviteTemplateToken}` : ``;

		return (
			<div className="col-lg-4 clearfix">
				<div className="formSectionSubTitle">{this.props.resources["PWS.MyAccount.PartyDetailsInvitationLabel"]}</div>
				<div className="emailStyle-thumb">
					<img rel="image_src" src={templateImage} alt={this.props.resources["PWS.MyAccount.InvitationStyle"]} />
				</div>
				{invitationButton}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/EInvitationContainer.js